import clsx from 'clsx'
import { Switch } from 'antd'
import { useTranslation } from 'react-i18next'
import { useAppDispatch } from '../../../../app/store/hooks/Redux'
import {
  CommaLists,
  GetAdvertiserReportsOrganicApiArg,
  useExportOrganicResults,
} from '../../../../app/api'
import { setHasBrand } from '../../model/organicResultsSlice'
import { AiButton } from '../../../../shared/components/ai/ai-button/AiButton'
import { useAiChat } from '../../../../shared/components/ai/ai-provider/AiProvider'
import { BpButton } from '../../../../shared/components/buttons/bp-button/BpButton'
import { ExportDrop } from '../../../../shared/components/cards/export-drop/ExportDrop'
import { IconMaximize } from '../../../../shared/components/icons/IconMaximize'
import { IconMinimize } from '../../../../shared/components/icons/IconMinimize'
import { IWithExpandedAllProps } from '../../../../shared/lib/hoc/WithExpanded'

import styles from './OrganicResultsActions.module.scss'

export interface IOrganicResultsActionsProps
  extends Pick<IWithExpandedAllProps, 'isExpandAll' | 'onToggleExpandAll'> {
  /** Текущий запрос таблицы: с ним же уходит выгрузка */
  queryParams: Partial<CommaLists<GetAdvertiserReportsOrganicApiArg>>
}

export const OrganicResultsActions = ({
  queryParams,
  isExpandAll,
  onToggleExpandAll,
}: IOrganicResultsActionsProps) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const { handleSendMessage } = useAiChat()
  const [exportOrganicResults, { isFetching: exportLoading }] = useExportOrganicResults()

  return (
    <div className={clsx(styles.root)}>
      {
        {
          bluepear: (
            <AiButton
              unstyled
              onClick={() =>
                handleSendMessage({
                  message:
                    'Please provide a clear guide on how to use the Organic Results Report and explain its value.',
                })
              }
            >
              How the report works
            </AiButton>
          ),
          robuscan: null,
          default: null,
        }[process.env.REACT_APP_PROJECT ?? 'default']
      }
      <span className={clsx(styles.hasBrandRow)}>
        {t('fields.hasBrand')}
        <Switch
          checked={queryParams?.hasBrand}
          onClick={() => dispatch(setHasBrand(!queryParams?.hasBrand))}
        ></Switch>
      </span>
      <span className={clsx(styles.buttonsRow)}>
        <BpButton
          iconLeft={isExpandAll ? <IconMinimize /> : <IconMaximize />}
          size='sm'
          theme='outline'
          type='button'
          onClick={() => onToggleExpandAll?.(!isExpandAll)}
        ></BpButton>
        <ExportDrop
          columns={[
            { keys: ['domain'], label: t('table.columns.domain') },
            { keys: ['pages_count'], label: t('table.columns.pages') },
            { keys: ['keywords_count'], label: t('table.columns.keywords') },
            { keys: ['affiliates_count'], label: t('table.columns.affiliates') },
            { keys: ['position'], label: t('table.columns.avgPosition') },
            { keys: ['previous_position'], label: t('table.columns.previousPosition') },
            { keys: ['last_found'], label: t('table.columns.lastFound') },
          ]}
          loading={exportLoading}
          onExport={(exportParams) => exportOrganicResults({ ...queryParams, ...exportParams })}
        />
      </span>
    </div>
  )
}
